'use client';
import React, { createContext, useContext, useState, useEffect } from 'react';
import { setLmsClientBaseUrl } from '@/lib/api/lmsClient';

interface Config {
  COMMUNITY_MANAGER_URL?: string;
  MOODLE_URL?: string;
  SITE_URL?: string;
  [key: string]: any;
}

interface ConfigContextType {
  config: Config;
  loading: boolean;
}

const ConfigContext = createContext<ConfigContextType | undefined>(undefined);

export const ConfigProvider = ({ children }: { children: React.ReactNode }) => {
  const [config, setConfig] = useState<Config>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await fetch('/api/config');
        if (res.ok) {
          const data = await res.json();
          setConfig(data);
          if (data.COMMUNITY_MANAGER_URL) {
            setLmsClientBaseUrl(data.COMMUNITY_MANAGER_URL);
          }
        }
      } catch (err) {
        console.error('Failed to load runtime configuration:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  return <ConfigContext.Provider value={{ config, loading }}>{children}</ConfigContext.Provider>;
};

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (context === undefined) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context.config;
};
